import PlaylistData from "./data/PlaylistData";
import { PlaylistItemData } from "./data/PlaylistItemData";
import ArrayUtils from "../common/ArrayUtils";
import { LookupSongFunction } from "../common/LookupSongFunction";
import { generateId } from "../common/UrlFriendlyNanoIdGeneration";

export const PlaylistManipulationUtils = {
  maxOfIds(items: ReadonlyArray<PlaylistItemData>): number {
    return Math.max(...items.map((v) => v.id), 0);
  },

  insertAfter(
    data: PlaylistData,
    itemToBeInserted: PlaylistItemData,
    itemId?: number,
  ): PlaylistData {
    const items =
      itemId === undefined
        ? data.getItems().concat(itemToBeInserted)
        : ArrayUtils.insertAfter(
            data.getItems(),
            (li: PlaylistItemData) => li.id === itemId,
            itemToBeInserted,
          );
    return data.copyWithItems([...items]);
  },

  setItems(data: PlaylistData, items: PlaylistItemData[]): PlaylistData {
    return data.copyWithItems(items);
  },

  createItemToInsert(
    items: ReadonlyArray<PlaylistItemData>,
    songEntryId: string,
  ) {
    const id = PlaylistManipulationUtils.maxOfIds(items) + 1;
    return { id, songEntryId };
  },

  buildItemsFromTocIdArray(tocIdArray: readonly string[]): PlaylistItemData[] {
    return tocIdArray.map((id, index) => {
      const itemInMemoryId = index + 1;
      return { id: itemInMemoryId, songEntryId: id };
    });
  },

  hasInvalidItemsWithNoCEntry(
    items: PlaylistItemData[],
    lookupSong: LookupSongFunction,
  ): boolean {
    return (
      items.filter((p) => lookupSong(p.songEntryId) === undefined).length > 0
    );
  },

  DuplicatorPostfix: " (Kopie)",

  /**
   * @param existing
   * @param belongsToCrew is optional, because we can copy a playlist from a crew to the personal playlist index
   */
  copyPlaylistFromExistingToCrew(
    existing: PlaylistData,
    belongsToCrew: string | undefined,
  ) {
    const adaptedTitle =
      existing.belongsToCrew === belongsToCrew
        ? existing.title + PlaylistManipulationUtils.DuplicatorPostfix
        : existing.title;
    return new PlaylistData(
      generateId(),
      adaptedTitle,
      belongsToCrew,
      existing.getTags(),
      existing.getItems(),
      new Date(),
      new Date(),
      0,
      true,
      false,
      false,
    );
  },
} as const;
